// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"aa198401","453":"842c90a1","455":"817d50e0","977":"1be02162"}[chunkId] + ".chunk.js";
};